import { LockCviIcon } from '../../components/icons-library/lock-cvi';
import { Show, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';

export const LockedContent = (props: { hasHero?: boolean, isColumn?: boolean, text?: string; }) => {
    const { localize, appStore } = useContext(AppContext);
    const { openLoginMenu } = appStore;

    const getMarginTop = () => {
        if (props.hasHero) {
            return appStore.isHcp() ? '31rem' : '24rem';
        }
        return appStore.isHcp() ? '24rem' : '12rem';
    };

    if (props.isColumn) {
        return (
            <div
                class="absolute inset-0 bg-cvi-bg-default rounded-[inherit] opacity-90 flex flex-col items-center z-0 pointer-events-auto cursor-pointer justify-center p-4 text-cvi-fg-default"
                onClick={openLoginMenu}
            >
                <div class="flex flex-col items-center gap-cvi-6">
                    <LockCviIcon size="xlarge" />
                    <div class="underline label-md font-cvi-medium text-cvi-fg-default transition-colors duration-200 max-w-[270px] text-center line-clamp-3 overflow-hidden text-ellipsis">
                        <Show
                            fallback={localize('unlock-gated-content', 'Unlock gated content')}
                            when={props.text}
                        >
                            {props.text}
                        </Show>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div
            class="absolute inset-0 bg-cvi-bg-default rounded-[inherit] opacity-90 flex flex-col items-center z-[1] pointer-events-auto cursor-pointer text-cvi-fg-default"
            onClick={openLoginMenu}
        >
            <div
                class="flex gap-cvi-6 flex-col justify-center items-center mb-40"
                style={{ 'margin-top': getMarginTop() }}
            >
                <LockCviIcon size="xlarge" />
                <div class="underline label-md font-cvi-medium text-cvi-fg-default transition-colors duration-200 max-w-[270px] text-center line-clamp-3 overflow-hidden text-ellipsis">
                    {localize('unlock-gated-content', 'Unlock gated content')}
                </div>
            </div>
        </div>
    );
};
